import { Component, Input, OnInit } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { IFilter } from '../../models/IFilter';
import { MatChip, MatChipInputEvent } from '@angular/material/chips';


const Filter = 'Filter';
const Choice = 'Choice';
const InputType = 'Input';

@Component({
  selector: 'ff-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss']
})
export class ChipComponent implements OnInit {

  isInput: boolean = true;
  isChoice: boolean = false;
  isFilter: boolean = false;

  /**
   * Options to display as radio buttons
   * Use the IFilter interface: { description: string; id: number; disabled?: boolean; }
   * * @internal
  */
  @Input() options: IFilter[] = [];

  /**
   * Chip Type.
   * Options: Input, Choice or Filter
   * Default value: Input
   * * @internal
   */
  @Input() chipType: string = 'Input';

  /**
   * Text to display if the chip type is Input
   * Default valie: Empty.
   * * @internal
   */
  @Input() elementType: string = '';

  removable: boolean = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor() { }

  ngOnInit(): void {
    if (this.chipType === Choice) {
      this.removable = true
      this.isInput = false;
    } else if (this.chipType === Filter) {
      this.isFilter = true;
      this.isInput = false;
      this.removable = false;
    } else if (this.chipType !== InputType) {
      this.chipType = 'Input';
    }
  }

  /**
   * Add a new element to the array.
   * @param event element with the new element to add
   */
  add = (event: MatChipInputEvent): void => {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      const lastElement = this.options[this.options.length - 1];
      if (!!lastElement) {
        this.options.push(
          {
            description: value.trim(),
            id: lastElement.id + 1
          });
      } else {
        this.options.push(
          {
            description: value.trim(),
            id: 0
          });
      }

    }

    if (input) {
      input.value = '';
    }

  }

  /**
   * Remove a single element of the list
   * @param option Filter to remove
   */
  remove = (option: IFilter): void => {
    const index = this.options.indexOf(option);
    if (index >= 0) {
      this.options.splice(index, 1);
    }
  }


  chipSelection = (chip: MatChip): void => {
    chip.toggleSelected();
  }
}
